import { menusData, IMenu } from "./menus";
import { useRouter } from "next/router";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import Icon from "@/components/Icon";

/**
 * mobile menu component
 */
const MobileMenu = () => {
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-0 left-0 z-50 grid h-[60px] w-full grid-cols-4 bg-white text-xs font-semibold shadow-[0_-1px_8px_0_rgba(117,117,117,0.1)] lg:hidden">
      {menusData.map((menu: IMenu, index) => {
        const isActive = router.pathname === menu.href;
        // 去掉.svg后缀，拼接icon name
        const iconName = (isActive ? menu.imgActiveUrl : menu.imgUrl).replace(
          ".svg",
          ""
        );

        return (
          <div
            className="relative flex flex-col items-center justify-center"
            key={index}
          >
            <Link
              href={menu.href}
              className="absolute left-0 top-0 z-10 h-full w-full"
              data-qt="mobile_tabbar_click"
              data-qt-nav-url={menu.href}
            />
            <Icon
              name={iconName}
              size={menu.imgHeight}
              title={t(menu.text)}
              isMobile
            />
            <div
              className={`mt-[3px] ${
                isActive ? "text-primary" : "text-stone-800"
              }`}
            >
              {t(menu.text)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MobileMenu;
